import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { useRecordContext, useTranslate } from 'react-admin';
import { Form } from 'antd';
import AntdReferenceSelectWithSearch from '../../../../../base/components/antd/AntdReferenceSelectWithSearch';
import resourceSlug from '../../../../../constant/resource-slug';

const CurrencySelect = (props) => {
  const t = useTranslate();
  const {
    input: { value: group },
  } = useField('group');
  const {
    input: { value: currencies },
  } = useField('currencies');
  const record = useRecordContext();

  const filters = useMemo(
    () => ({
      'groups.id||$in': group?.id,
      'enabled||$eq': true,
      ...(!!currencies?.length && {
        'id||$notin': currencies.reduce((list, item) => (item.id !== props.value?.id ? [item.id, ...list] : list), []),
      }),
      ...(!!record?.id && {
        skipBrandACL: true,
      }),
    }),
    [currencies, props.value?.id, record?.id, group?.id],
  );

  return (
    <Form.Item
      name="currency"
      rules={[
        {
          required: true,
          message: t('ra.validation.required'),
        },
      ]}
    >
      <AntdReferenceSelectWithSearch
        placeholder={t('resources.currency.name')}
        reference={resourceSlug.CURRENCY}
        filter={filters}
        {...props}
      />
    </Form.Item>
  );
};

export default CurrencySelect;
